import Vue from 'vue';

import Vuex from 'vuex';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    right_state:0,
    sign: "", //sign
    version:'1.0.0',  //版本号
    userinfo: {}, // 用户信息
  },
  mutations: {
    change_right_state(e){
      this.right_state = e
    },
    changeUserinfo(state, data) {
			state.userinfo = data;
			if (data.uid) {
				data = JSON.stringify(data);
        localStorage.setItem('userinfo',data)
			} 
		},
		setSign(state, data) {
			state.sign = data;
      localStorage.setItem('sign',data)
		},
  },
  actions: {
  },
  modules: {
  }
})
